export default __webpack_public_path__ + "static/media/card2400.f1129c99.jpg";